import styled from 'styled-components';
import COLORS from '../../../utils/Colors';

interface ErrorMessageProps {
  visible: boolean;
}

interface buttonProps {
  codeBtnDisabled: boolean;
}

export const Grid = styled.div`
    display: flex;
    height: 100vh;

    @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
      flex-direction: column;
    };
`;

export const Title = styled.h3`
    font-size: 1.875rem;
    font-weight: 500;
    color: ${COLORS.white};
`;

export const Label = styled.label`
    font-size: 1.125rem;
    color: ${COLORS.hsl210004055};
`;

export const LoginTitle = styled.h3`
    font-size: 2rem;
    font-weight: bold;
    color: hsl(204, 100%, 22%);
    margin-bottom: 3rem;
`;

export const CustomText = styled.p`
    font-size: 1.5rem;
    color: ${COLORS.white};
    line-height: 2.125rem;
`;

export const InfoSide = styled.div`
  flex: 1;
  padding: 10% 4.875rem;
`;

export const RightSide = styled.div`
  background-color: ${COLORS.white};
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const LoginSection = styled.div`
  padding: 20% 15%;
  height: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
      padding: 10.625rem 3rem;
  };
`;

export const ActionBtn = styled.button<buttonProps>`
  width: 406px;
  height: 52px;
  align-items: center;
  padding: 0.8rem 0;
  background-color: ${COLORS.mainTealDark};
  border-radius: 24px;
  border: 0;
  color: ${COLORS.hsl000100099};
  font-weight: 500;
  font-size: 1.125rem;
  margin-top: 2rem;
  cursor: pointer;
  opacity: ${({ codeBtnDisabled }) => codeBtnDisabled === true ? `50%` : `100%`};

   &:disabled {
    cursor: not-allowed;
  }
`;

export const ErrorMessageText = styled.p`
    color: ${COLORS.hsl003100059};
    font-size: 0.9375rem;
    margin: 0.5rem 0 0 0;
`;

export const ErrorMessageDiv = styled.div<ErrorMessageProps>`
  visibility: ${({ visible }) => visible === true ? 'none' : 'hidden'};
`;

export const LoaderDiv = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const LoaderText = styled.p`
  color: #6b7280;
  font-size: 16px;
  text-align: center;
  margin: 0;
`;

export const InputContainer = styled.div`
    height: 5.5625rem;
    width: 50rem;
    margin-bottom: 7rem;
    margin-top: 5.25rem;
    width: 100% !important;

    & input {
      border-width: 0 !important;
      border-bottom-width: 1px !important;
      border-radius: 0 !important;
      margin-right: 22px !important;
      font-family: 'Helvetica Neue', sans-serif;
      color: ${COLORS.hsl218001016};
      border-color: ${COLORS.hsl210003087};
      font-size: 1.5rem;
    }

    & input:focus {
      border-color: ${COLORS.hsl210003050};
    }

    & .styles_react-code-input-container__tpiKG { 
      width: 100% !important;
    }
`;

export const Label2 = styled.label`
    font-size: 1.125rem;
    color: ${COLORS.hsl218001016};
    letter-spacing: 0.18px;
`;

export const MessageError = styled.p`
    color: ${COLORS.hsl003079056};
    font-size: 0.875rem;
    margin-top: 1.25rem;
`;



